import { AccountSidebar } from "../account/AccountSidebar"
import Box from "@mui/material/Box"
import React from "react"
import { Outlet } from "react-router-dom"
import useMediaQuery from "@mui/material/useMediaQuery"

export const AccountLayout = () => {
  const drawerWidth = 260
  const isDownSm = useMediaQuery("(max-width: 600px)")

  return (
    <Box // pt={2} pb={4}
      sx={{ minHeight: "100vh", display: "flex" }}
    >
      {!isDownSm && <AccountSidebar />}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          py: { xs: 2, sm: 0 },
          px: { xs: 2, sm: 4 },
          width: { sm: `calc(100% - ${drawerWidth}px)` },
          maxWidth: "xl",
          mx: "auto",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  )
}
